function mode({development = '', staging = '', production = ''}) {
  const mode = process.env.SPOTIN_ENV || 'development';
  switch(mode) {
    case 'development':
      return development;
    case 'staging':
      return staging;
    case 'production':
      return production;
    default:
      throw new Error(`Mode is invalid ${mode}`);
  }
}

module.exports ={
  getMode: () => {
    return mode({
      development: 'development',
      staging: 'staging',
      production: 'production'
    });
  },
  getBaseDomain: () => {
    return mode({
      development: 'dev.spotin.com',
      staging: 'staging.spotin.com',
      production: 'spotin.com'
    });
  },
  getPort: () => {
    return mode({
      development: ':3000',
      staging: '',
      production: ''
    });
  },
  getProtocol: () => {
    return mode({
      development: 'http',
      staging: 'https',
      production: 'https'
    });
  },
  getGATrackerId: () => {
    return mode({
      development: 'UA-93676837-5',
      staging: 'UA-93676837-6',
      production: 'UA-93676837-7'
    });
  },
  getScriptUrls: () => {
    const prefix = module.exports.getProtocol();
    const url = module.exports.getBaseDomain();
    const port = module.exports.getPort();

    return {
      spotin: prefix + '://app.' + url + '/spotin-demo.js',
      spotinNonDemo: prefix + '://app.' + url + '/spotin.js',
      demoSite: prefix + '://' + url + port + '/demo_bundle.js',
      mainSite: prefix + '://' + url + port+ '/main_bundle.js'
    };
  }
};



// WEBPACK FOOTER //
// ./constants.js